import { mouseEvents, sGisEvent } from "./EventHandler";
export class sGisMouseEvent extends sGisEvent {
    constructor({ type, flag }, { point, browserEvent }) {
        super(type);
        this.point = point;
        this.browserEvent = browserEvent;
        this.eventFlag = flag;
    }
}
export class sGisClickEvent extends sGisMouseEvent {
    constructor(params) {
        super(mouseEvents.click, params);
    }
}
sGisClickEvent.type = mouseEvents.click.type;
sGisClickEvent.eventFlag = mouseEvents.click.flag;
export class sGisDoubleClickEvent extends sGisMouseEvent {
    constructor(params) {
        super(mouseEvents.doubleClick, params);
    }
}
sGisDoubleClickEvent.type = mouseEvents.doubleClick.type;
sGisDoubleClickEvent.eventFlag = mouseEvents.doubleClick.flag;
export class sGisMouseMoveEvent extends sGisMouseEvent {
    constructor(params) {
        super(mouseEvents.mouseMove, params);
    }
}
sGisMouseMoveEvent.type = mouseEvents.mouseMove.type;
sGisMouseMoveEvent.eventFlag = mouseEvents.mouseMove.flag;
export class sGisMouseOutEvent extends sGisMouseEvent {
    constructor(params) {
        super(mouseEvents.mouseOut, params);
    }
}
sGisMouseOutEvent.type = mouseEvents.mouseOut.type;
sGisMouseOutEvent.eventFlag = mouseEvents.mouseOut.flag;
export class sGisMouseOverEvent extends sGisMouseEvent {
    constructor(params) {
        super(mouseEvents.mouseOver, params);
    }
}
sGisMouseOverEvent.type = mouseEvents.mouseOver.type;
sGisMouseOverEvent.eventFlag = mouseEvents.mouseOver.flag;
export class DragStartEvent extends sGisMouseEvent {
    constructor(draggingObject, params) {
        super(mouseEvents.dragStart, params);
        this.draggingObject = draggingObject;
    }
}
DragStartEvent.type = mouseEvents.dragStart.type;
DragStartEvent.eventFlag = mouseEvents.dragStart.flag;
export class DragEvent extends sGisMouseEvent {
    constructor({ point, browserEvent, offset, pxOffset }) {
        super(mouseEvents.drag, { point, browserEvent });
        this.offset = offset;
        this.pxOffset = pxOffset;
    }
}
DragEvent.type = mouseEvents.drag.type;
DragEvent.eventFlag = mouseEvents.drag.flag;
export class DragEndEvent extends sGisMouseEvent {
    constructor(params) {
        super(mouseEvents.dragEnd, params);
    }
}
DragEndEvent.type = mouseEvents.dragEnd.type;
DragEndEvent.eventFlag = mouseEvents.dragEnd.flag;
